import common from '../common'

export default {
    list(params) {
      return common.get('/rocheManage/sys/notice/list',params);
    },
  
    add(params) {
      return common.post('/rocheManage/sys/notice/add',params);
    },
  
    edit(params) {
      return common.put('/rocheManage/sys/notice/edit',params);
    },
  
    delete(params) {
      return common.delete('/rocheManage/sys/notice/delete',params);
    },
  
    deleteBatch(params) {
      return common.delete('/rocheManage/sys/notice/deleteBatch',params);
    },

    getNoticeHomeList() {
      return common.get('/rocheManage/sys/notice/home/list');
    },

    exportXls(params) {
      return common.get('/rocheManage/sys/notice/exportXls', params, {responseType: 'blob'});
    },

    getUserList() {
      return new Promise((resolve, reject) => {
          this.list({
                pageNo: 1,
                pageSize: 999999
                })
                .then(res => {
                  let temp = res.records.map((r) => {return {username:r.updateBy,realname:r.updateBy}});
                  temp = _.uniqBy(temp,'username')
                  resolve(temp);
                })
      })
    }
}


// WEBPACK FOOTER //
// ./src/api/sysmanagement/systemnotice.js